import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from '@ngx-translate/core';
import { GetProductMigrationService } from '../../services/get-product-migration.service';

@Component({
  selector: 'app-migration',
  templateUrl: './migration.component.html',
  styleUrls: ['./migration.component.scss']
})
export class MigrationComponent implements OnInit {
  code: string = '';

  constructor(
    public dialog: MatDialog,
    private migrationCodeServ: GetProductMigrationService,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
  ) {
  }

  async ngOnInit() {
    const result = await this.migrationCodeServ.make();
    this.code = result.code;
  }

  copyInputMessage(text: any) {
    const selBox = document.createElement('textarea') as HTMLTextAreaElement;
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = text;
    document.body.appendChild(selBox);
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snackBar.open(this.translate.instant('Sellers.Products.CopiedToClipboard'), '', { duration: 2000 });

  }
}
